module.exports = __webpack_public_path__ + "static/media/z-Zero.2c421b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/z-Zero.png
// module id = 195
// module chunks = 0